import React from 'react';
import DataViewerChildBaseProps from './DataViewerChildBaseProps';

export interface DataViewerFieldBaseProps extends DataViewerChildBaseProps {
    label?: React.ReactNode;
}

export default abstract class DataViewerFieldBase<P extends DataViewerFieldBaseProps> extends React.Component<P & React.TdHTMLAttributes<HTMLTableDataCellElement>> {}
